import { useParams } from "react-router-dom";
import { z } from "zod";

const paramsSchema = z.string();
/**
 * API が採番する ID は ULID（Crockford Base32 の 26 文字）。
 * uuid で検証すると、実データを載せた URL が例外で落ちる。
 */
const paramsULIDSchema = z.string().regex(/^[0-7][0-9A-HJKMNP-TV-Z]{25}$/, {
  message: "ULID の形式ではありません",
});

type URLTypes = "ulid" | undefined;

interface UseURLDynamicParamArgs<K extends string> {
  paramName: K;
  type?: URLTypes;
}

// 型からジェネリクスKを取り出して、paramNameと返り値のkeyの文字列の一致を補完させる
export const useURLDynamicParam = <K extends string>({
  paramName,
  type,
}: UseURLDynamicParamArgs<K>): Record<K, string> => {
  const params = useParams<{ [key: string]: string }>();
  const paramValue = params[paramName];

  if (type === "ulid") {
    const parsedParamValue = paramsULIDSchema.parse(paramValue);

    return { [paramName]: parsedParamValue } as Record<K, string>;
  }

  const parsedParamValue = paramsSchema.parse(paramValue);

  return { [paramName]: parsedParamValue } as Record<K, string>;
};
